import { Shape } from "../common/mod.js"
import { array } from "./array.js"
import { str } from "./str.js"
import { transform } from "./transform.js"
import { tuple } from "./tuple.js"

export function record<I, O>($value: Shape<I, O>): Shape<Readonly<Record<string, I>>, Record<string, O>> {
  return transform({
    $base: array(tuple(str, $value)),
    encode: Object.entries,
    decode: Object.fromEntries,
  })
}
